/**
 * Created by Administrador on 11/08/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('farePublishService', farePublishService);

    farePublishService.$inject = ['$http', 'CONFIG', 'messageService'];

    function farePublishService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_KJAR_SERVICE + '/' + CONFIG.API ;
        var service = {
            generateFares: generateFares,
            generateTaxes: generateTaxes,
            publishFares: publishFares,
            getGeneralManifesto: getGeneralManifesto
        }

        return service;

        function generateFares(){
            return $http.post(urlBase + '/kjar/publish')
                .then(function(response){
                    messageService.register('faresPublished');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('faresPublished');
                });
        }

        function generateTaxes(){
            return $http.post(urlBase + '/kjar/taxes')
                .then(function(response){
                    messageService.register('faresPublished');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('faresPublished');
                });
        }

        function publishFares(value){
            return $http.post(urlBase + "/kie/" + value)
                .then(function(response){
                    messageService.register('faresPublished');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('faresPublished');
                });
        }

        function getGeneralManifesto(){
            urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/reports/luggageManifest/pdf';
            return $http.get(urlBase + '?departureFlightId=527',{responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('faresPublished');
                });
        }
    };

})();
